import {
  GET_CLEAR_AUTOCOMPLETE,
	GET_CLEAR_DIRECTION,
	GET_GEOCODE_FAILED,
	GET_GEOCODE_REQUESTED,
  GET_GEOCODE_SUCCESS,
  GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED,
  GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED,
  GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS,
  GET_GOOGLE_MAP_DIRECTION_FAILED,
  GET_GOOGLE_MAP_DIRECTION_REQUESTED,
  GET_GOOGLE_MAP_DIRECTION_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_FAILED,
  GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED,
  GET_GOOGLE_NEARBY_SEARCH_FAILED,
  GET_GOOGLE_NEARBY_SEARCH_REQUESTED,
  GET_GOOGLE_NEARBY_SEARCH_SUCCESS,
  GET_LOCATIONCHECK_FAILED,
  GET_LOCATIONCHECK_REQUESTED,
  GET_LOCATIONCHECK_SUCCESS,
  GET_LOCATIONCHECK_CLEAR
} from "resources/actionTypes";

const intialState = {
  userAutoComplete: [],
  loading: false,
  error: null,
};
const intialDirectionState = {
  userDirection: [],
  loading: false,
  error: null,
};
const intialPlaceDetailsState = {
    pickup: [],
    drop: [],
  loading: false,
  error: null,
};
const intialStateGeo = {
  userGeocode: [],
  loading: false,
  error: null,
};

const intialLocationCheck = {
  userLocationCheck: [],
  loading: false,
  error: null,
};
export function userAutoComplete(state = intialState, action) {
  switch (action.type) {
    case GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAutoComplete: action.userAutoComplete,
      };
    case GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_CLEAR_AUTOCOMPLETE:
      return{
        ...state,
        loading: false,
        userAutoComplete: [],

      }
    default:
      return state;
  }
}
export function userNearBySearch(state = intialState, action) {
  switch (action.type) {
    case GET_GOOGLE_NEARBY_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLE_NEARBY_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        userNearBySearch: action.userNearBySearch,
      };
    case GET_GOOGLE_NEARBY_SEARCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userPlaceDetails(state = intialPlaceDetailsState, action) {
  switch (action.type) {
    case GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        pickup:action.userPlaceDetails
      };
      case GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS:
        return {
          ...state,
          loading: false,
          drop:action.userPlaceDetails
        };
    case GET_GOOGLE_MAP_PLACE_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userDirection(state = intialDirectionState, action) {
  switch (action.type) {
    case GET_GOOGLE_MAP_DIRECTION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLE_MAP_DIRECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        userDirection: action.userDirection,
      };
    case GET_GOOGLE_MAP_DIRECTION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_CLEAR_DIRECTION:
      return {
        ...state,
        loading: false,
        userDirection:"",
      }
    default:
      return state;
  }
}
export function userGeocode(state = intialStateGeo, action) {
  switch (action.type) {
    case GET_GEOCODE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_GEOCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        userGeocode: action.userGeocode,
      };
    case GET_GEOCODE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userLocationCheck(state = intialLocationCheck, action) {
  switch (action.type) {
    case GET_LOCATIONCHECK_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATIONCHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        userLocationCheck: action.userLocationCheck,
      };
    case GET_LOCATIONCHECK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_LOCATIONCHECK_CLEAR:
      return{
        ...state,
        loading: false,
        userLocationCheck: [],

      }
    default:
      return state;
  }
}
